module.exports = __webpack_public_path__ + "static/media/4.7a58c014.jpg";